import EventBus from '@/eventBus'

export default {
  handleAIGenerateSlideEvent(editor, doc) {
    EventBus.$emit('slide-generator:generated', doc)
  },
}
